// extracted by mini-css-extract-plugin
export default {"wrapper":"ProgressCell_wrapper__DaKv+","progressBar":"ProgressCell_progressBar__RnAXZ","resolved":"ProgressCell_resolved__PXr94","unresolved":"ProgressCell_unresolved__HNnuB"};